import { Send } from "lucide-react";

/**
 * Заглушка для экранов, которым нужна авторизация. Витрину и статьи можно
 * смотреть в обычном браузере (удобно при вёрстке), но заказы и профиль
 * привязаны к пользователю, а подписанный initData бывает только внутри Telegram.
 */
export function NeedTelegram({ what }: { what: string }) {
  return (
    <div className="state">
      <Send size={28} strokeWidth={1.4} aria-hidden />
      <div>
        {what} доступен только внутри Telegram.
        <br />
        Откройте приложение через бота.
      </div>
    </div>
  );
}
